export const SITE_HEADER_ID = 'site-header';
